export const globalGetters = {
  socialEntities: 'socialEntity/socialEntities'
}

export const getters = {
  socialEntities: state => state.socialEntities
}
